import React from 'react';
import { Link } from 'react-router-dom';
import { Users } from 'lucide-react';

/**
 * CMS-powered Membership CTA component
 * Accepts CMS data as props but maintains exact HTML structure and styling
 */
export const MembershipCTACMS = ({ cmsContent = null }) => {
  // Default content
  let heading = "Join The Clubhouse";
  let subheading = "Become a Golf Nuts member";
  let description = "Get exclusive access to bonus content, early episodes, community events, and more. The clubhouse is always open.";
  let benefits = [
    {
      title: "Member Giveaways",
      description: "Exclusive contests for engaged subscribers"
    },
    {
      title: "Member Clubhouse App Access",
      description: "Our private community experience"
    },
    {
      title: "Clubhouse GHIN Tracker",
      description: "Leaderboards & monthly/quarterly competitions"
    }
  ];
  let ctaText = "Join Free Today";
  let ctaUrl = "/membership";

  // If CMS content is provided, extract and merge
  if (cmsContent && cmsContent.blocksData) {
    const blocks = cmsContent.blocksData.filter(b => b.isVisible);
    
    // First block is main heading/description
    if (blocks[0] && blocks[0].blockType === 'text_block') {
      heading = blocks[0].content.heading || heading;
      subheading = blocks[0].content.subheading || subheading;
      description = blocks[0].content.body || description;
    }
    
    // Next 3 blocks are benefits
    const benefitBlocks = blocks.filter(b => b.blockType === 'text_block').slice(1, 4);
    if (benefitBlocks.length > 0) {
      benefits = benefitBlocks.map(block => ({
        title: block.content.heading || '',
        description: block.content.body || ''
      }));
    }
    
    // CTA button block
    const ctaBlock = blocks.find(b => b.blockType === 'cta_buttons');
    if (ctaBlock && ctaBlock.content.buttons && ctaBlock.content.buttons[0]) {
      ctaText = ctaBlock.content.buttons[0].text || ctaText;
      ctaUrl = ctaBlock.content.buttons[0].url || ctaUrl;
    }
  }

  return (
    <section className="membership-cta-section">
      <div className="container">
        <div className="membership-cta-inner">
          <div className="membership-text-content">
            <h2 className="display-medium">{heading}</h2>
            {subheading && <p className="membership-subheading">{subheading}</p>}
            <p className="membership-description">{description}</p>
            <Link to={ctaUrl} className="btn-accent btn-large membership-cta-button">
              {ctaText}
            </Link>
          </div>
          
          <div className="membership-benefits-cards">
            {benefits.map((benefit, index) => (
              <div key={`benefit-${benefit.title || 'item'}-${index}`} className="membership-benefit-card">
                <div className="benefit-card-icon">
                  <Users size={24} />
                </div>
                <h3 className="benefit-card-title">{benefit.title}</h3>
                <p className="benefit-card-description">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
